import moment from 'moment'
import { groupBillSku } from '@/utils/modules/print'
import { getUser, getCurrentBranchPOS, getBranchID } from '@/utils/helper/localStorage'
import PrintProvider from '@/resources/print_provider'

const printService = new PrintProvider()

const state = {
  printer: []
}
const actions = {
  async fetchPrinters ({commit}) {
    let branchID = getBranchID()
    let res = await printService.getPrinters(branchID)
    commit('SET_PRINTER', res.data)
  },
  async printReceiptAction ({ getters }, payload) {
    const user = getUser()
    const currentBranchPos = getCurrentBranchPOS()
    const receiptData = {
      billId: getters.getOrder.bill.id,
      branchPos: {
        branchId: parseInt(currentBranchPos.branch_id),
        name: currentBranchPos.name,
        posId: currentBranchPos.pos_id,
        taxId: 'TAX#0-1055-61034-56-1',
        unitId: parseInt(currentBranchPos.unit_id),
        code: currentBranchPos.warehouse
      },
      payment: {
        type: getters.getReceivedCard === 0 ? 'cash' : 'credit',
        receivedCash: parseFloat(getters.getReceivedCash),
        receivedCredit: parseFloat(getters.getReceivedCard),
        change: parseFloat(getters.getChange)
      },
      items: groupBillSku(getters.getItems),
      discount: parseFloat(getters.discount),
      print: {
        message: '',
        status: 'pending',
        ip: payload.printerIP
      },
      fullPrice: parseFloat(getters.getFullPrice),
      price: getters.getNetPrice,
      cashier: {
        id: parseInt(user.id),
        first_name: user.first_name,
        last_name: user.last_name
      },
      displayTime: moment(getters.getTime).format('DD-MM-YYYY HH:mm'),
      member: getters.getMemberOrderHistory.data ? getters.getMemberOrderHistory.data.member : {},
      storeDisplayName: 'Gentlewoman',
      storeLogo: 'https://gentlewoman-management.s3-ap-southeast-1.amazonaws.com/receipt-image/gw-logo-shop.png'
    }
    if (payload.printerIP === 'no print') {
      receiptData.print.status = 'no_print'
    }
    await printService.printReceipt(receiptData)
  }
}

const mutations = {
  SET_PRINTER (state, payload) {
    state.printer = payload
  }
}

const getters = {
  getPrinters: (state) => {
    return state.printer
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/print.js